import { render, staticRenderFns } from "./ComplaintsFilter.vue?vue&type=template&id=075404a0&scoped=true&"
import script from "./ComplaintsFilter.vue?vue&type=script&lang=js&"
export * from "./ComplaintsFilter.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintsFilter.vue?vue&type=style&index=0&id=075404a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075404a0",
  null
  
)

export default component.exports